export enum PathNames {
  HOME = 'HOME',
  LOGIN = 'LOGIN',
  USERS = 'USERS',
  PROJECTS = 'PROJECTS',
  PROJECT = 'PROJECT',
  PROJECT_TAB = 'PROJECT TAB',
  PROJECT_OVERVIEW_TAB = 'PROJECT OVERVIEW TAB',
  PROJECT_ANNOTATORS_TAB = 'PROJECT ANNOTATORS TAB',
  PROJECT_REVIEWERS_TAB = 'PROJECT REVIEWERS TAB',
  PROJECT_JOBS_TAB = 'PROJECT JOBS TAB',
  PROJECT_STATS_TAB = 'PROJECT STATS TAB',
  NEW_PROJECT = 'NEW PROJECT',
  CASE_SEARCH = 'CASE SEARCH',
  AI_OPERATIONAL = 'AI OPERATIONAL',
  REPORTS = 'REPORTS',
  ASSET_TEMPLATES = 'ASSET TEMPLATES',
  NEW_ASSET_TEMPLATE = 'NEW ASSET TEMPLATE',
  MANAGE_ASSET_TEMPLATE = 'MANAGE ASSET TEMPLATE',
}
